import React, { useState } from 'react';
import Papa from 'papaparse';
import axios from 'axios';
import GLOBALVAR from '../constants'; // Import GLOBALVAR constant

const ImportApplicant = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const data = results.data;

        for (let row of data) {
          // Prepare the payload for the API
          const payload = {
            firstName: row['First Name'] || 'Placeholder First Name',
            lastName: row['Last Name'] || 'Placeholder Last Name',
            middleName: row['Middle Name'] || '',
            mothersMaidenName: 'Placeholder Maiden Name',
            street: 'Placeholder Street',
            barangay: 'Placeholder Barangay',
            municipality: 'Placeholder Municipality',
            province: 'Placeholder Province',
            zipCode: 'Placeholder Zip Code',
            birthday: '1900-01-01', // Placeholder date
            gender: 'Placeholder Gender',
            civilStatus: 'Placeholder Civil Status',
            marriedTo: 'Placeholder Married To',
            telephoneNo: 'Placeholder Telephone No',
            mobileNo1: 'Placeholder Mobile No 1',
            mobileNo2: 'Placeholder Mobile No 2',
            emailAddress: 'placeholder@example.com',
            sssOrGsis: 'Placeholder SSS or GSIS',
            passport: 'Placeholder Passport',
            employerDetails: 'Placeholder Employer Details',
            employerAddress: 'Placeholder Employer Address',
            employerContactNumber: 'Placeholder Employer Contact Number',
            employerLocation: 'Placeholder Employer Location',
            is_deleted: false,
          };

          try {
            // Check if the application already exists
            const checkResponse = await axios.get(
              `${GLOBALVAR['SERVER_ROOT']}/api/applications/check`,
              {
                params: {
                  firstName: payload.firstName,
                  lastName: payload.lastName,
                },
              }
            );

            if (checkResponse.data.exists) {
              // Update existing application
              const updateResponse = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/api/applications/update/${checkResponse.data.id}`,
                payload
              );
              console.log('Application updated successfully!', updateResponse.data);
            } else {
              // Create new application
              const createResponse = await axios.post(
                `${GLOBALVAR['SERVER_ROOT']}/api/applications/add`,
                payload
              );
              console.log('Application submitted successfully!', createResponse.data);
            }
          } catch (error) {
            console.error('Error processing application:', error);
          }
        }

        alert('CSV import complete!');
      },
    });
  };

  return (
    <div>
      <h1>CSV Import</h1>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={handleImport}>Import CSV</button>
    </div>
  );
};

export default ImportApplicant;
